import { cn } from '#src/styling/cn.ts';
import type { ComponentProps } from 'react';

export type InputProps = ComponentProps<'input'>;

export const Input = ({ className, type, ...props }: InputProps) => {
  return (
    <input
      type={type}
      className={cn(
        'h-11 w-full rounded-sm border border-gray-300 bg-transparent px-3 py-1 transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-gray-400 hover:border-gray-400 focus-visible:border-violet-600 focus-visible:outline-hidden disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...props}
    />
  );
};
